var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 161,
    viewBox: "0 0 480 161",
    width: 480,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#faf7f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m151.009 10.3151h-9.956v55.623h9.956v-22.7789h29.975v-9.9592h-29.975zm39.932 65.5822h-39.932v-9.9592h39.932zm0-65.5822h-39.932v-9.959153h39.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.385 75.8973h10.062v-67.17141h25.209v-8.47589h-60.48v8.47589h25.209z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.047 75.8973h10.062v-34.6452h39.826v34.6452h10.062v-75.6473h-10.062v32.5262h-39.826v-32.5262h-10.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.941 150.291v9.959h-39.932v-9.959zm-49.888-65.5824h9.956v65.5824h-9.956z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.855 94.6678v-9.9592h19.913v9.9592zm0 9.9592h-9.956v-9.9592h9.956zm39.826 0v55.623h-9.956v-22.779h-39.826v22.779h-9.956v-55.623h9.956v22.885h39.826v-22.885zm-19.913 0v-9.9592h9.957v9.9592z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.101 160.25h10.063v-67.1714h25.209v-8.4759h-60.48v8.4759h25.208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.393 94.6678v-9.9592h19.912v9.9592zm0 9.9592h-9.957v-9.9592h9.957zm39.825 0v55.623h-9.956v-22.779h-39.826v22.779h-9.956v-55.623h9.956v22.885h39.826v-22.885zm-19.913 0v-9.9592h9.957v9.9592z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.692 160.25h9.532v-62.9335h.212l23.62 62.9335h8.58l23.62-62.9335h.211v62.9335h9.533v-75.6473h-13.769l-23.938 63.5693-23.832-63.5693h-13.769z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.5789.25-17.8947 26.6667-17.8947-26.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.6842 73.2325-4.5614 7.0175 4.5614 7.0175 4.5614-7.0175z"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.6842 55.6886-16.4912 24.5614 16.4912 24.561 16.4912-24.561zm0 7.0175-11.5789 17.5439 11.5789 17.5439 11.579-17.5439z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2632 80.25 28.421-42.807 28.4211 42.807-28.4211 42.807zm4.9122 0 23.5088-35.0877 23.5088 35.0877-23.5088 35.088z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.5789 53.5833 17.8948-26.6666h-35.7895-35.7895l17.8948 26.6666h-35.7895l17.8947 26.6667-17.8947 26.667h35.7895l-17.8948 26.666h35.7895l-17.8947 26.667h35.7894l-17.8947-26.667h35.7895l-17.8948-26.666h35.7891l-17.8943-26.667 17.8943-26.6667zm0 0-17.8947-26.6666-17.8947 26.6666-17.8948 26.6667 17.8948 26.667 17.8947 26.666 17.8947-26.666 17.8948-26.667z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.29f61bf3be4b2f90ab45329be1cd9322.svg";
export { ForwardRef as ReactComponent };